import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Models from "@/pages/Models";
import ModelDetail from "@/pages/ModelDetail";
import Vote from "@/pages/Vote";
import Pricing from "@/pages/Pricing";
import CheckoutReturn from "@/pages/CheckoutReturn";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AdminUpload from "@/pages/AdminUpload";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-black text-white flex items-center justify-center"><div className="overline">Loading…</div></div>;
  if (!user) return <Navigate to="/login" replace/>;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace/>;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  // Detect OAuth return before running normal routes
  if (location.hash?.includes("session_id=")) return <AuthCallback/>;
  return (
    <Routes>
      <Route path="/" element={<Landing/>}/>
      <Route path="/login" element={<Login/>}/>
      <Route path="/signup" element={<Signup/>}/>
      <Route path="/models" element={<Models/>}/>
      <Route path="/models/:modelId" element={<ModelDetail/>}/>
      <Route path="/vote" element={<Vote/>}/>
      <Route path="/pricing" element={<Pricing/>}/>
      <Route path="/checkout/return" element={<CheckoutReturn/>}/>
      <Route path="/dashboard" element={<Protected><Dashboard/></Protected>}/>
      <Route path="/admin" element={<Protected adminOnly><Admin/></Protected>}/>
      <Route path="/admin/upload" element={<Protected adminOnly><AdminUpload/></Protected>}/>
      <Route path="*" element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes/>
          <Toaster position="bottom-right" theme="dark" toastOptions={{
            style: { background: "#0a0a0a", color: "#fff", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 0, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, letterSpacing: "0.05em" }
          }}/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
